const getWindowConfig = () => {
    if (typeof window === 'undefined') return {}

    const cfg = window.__APP_CONFIG__ || {}

    return {
        apiBaseUrl: cfg.apiBaseUrl || window.baseUrl,
        newApiBaseUrl: cfg.newApiBaseUrl || window.newApiBaseUrl,
        bannerBaseUrl: cfg.bannerBaseUrl || window.bannerBaseUrl,
        newImageUrl: cfg.newImageUrl || window.newImageUrl,
    }
}

const appConfig = new Proxy({}, {
    get(_target, prop) {
        const cfg = getWindowConfig()
        return cfg[prop]
    }
})

export default appConfig
